import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import type { StoredDocument } from '../../../server/services/documentStorageService'

interface DocumentsSummaryProps {
  documents: StoredDocument[]
  selectedCount: number
}

export function DocumentsSummary({
  documents,
  selectedCount,
}: DocumentsSummaryProps) {
  const successfulCount = documents.filter(
    (d) => d.metadata.status === 'signed',
  ).length
  const failedCount = documents.filter(
    (d) => d.metadata.status === 'failed',
  ).length
  const invertedCount = documents.filter((d) => d.metadata.inverted).length

  return (
    <Box sx={{ mt: 3 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Toplam {documents.length} evrak • {successfulCount} başarılı •{' '}
          {failedCount} başarısız • {invertedCount} yasaklı
          {selectedCount > 0 && <> • {selectedCount} seçili</>}
        </Typography>
      </Paper>
    </Box>
  )
}
